import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/Router/Pages'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
